<template>
  <b-tabs end>
    <div
      v-for="(docsPorDep, $indexDepart) in valueInner"
      ref="modelodocumento"
      :key="docsPorDep.departamento.id"
    >
      <b-tab :title="docsPorDep.departamento.nome">
        <tabela-documento
          :ref="`docspordepartamento${docsPorDep.departamento.id}`"
          :value="docsPorDep.documentos"
          :colunas="colunasDocumento"
          :mostrar-selecionados="true"
          :is-empresa-docs="true"
          :filtrar-pos-selecao="!documentosDaEmpresa"
          @documento-selecionado="documentoSelecionado($indexDepart, docsPorDep.departamento, $event)"
        >
          <template v-slot:customizado="slotProps">
            <span
              v-if="slotProps.customizado.column.field === 'acoes'"
              style="float:right!important;"
              @click.prevent.stop
            >
              <b-btn
                v-b-tooltip.hover
                variant="none"
                class="btn btn-outline-success btn-none rounded-pill btn-none"
                style="padding: 0.4rem;margin-right: 0.3rem;"
                size="sm"
                title="Tag"
                @click.prevent.stop="adicionarTag($indexDepart, slotProps.customizado.row)"
              >
                <feather-icon
                  style=""
                  icon="TagIcon"
                />
              </b-btn>
              <b-btn
                v-b-tooltip.hover
                variant="none"
                class="btn btn-outline-primary btn-none rounded-pill btn-none"
                style="padding: 0.4rem;margin-right: 0.3rem;"
                size="sm"
                title="Copiar"
                @click.prevent.stop="copiar($indexDepart, docsPorDep.departamento, slotProps.customizado.row)"
              >
                <feather-icon
                  style=""
                  icon="CopyIcon"
                />
              </b-btn>
              <b-btn
                v-b-tooltip.hover
                variant="none"
                :class="['btn btn-none rounded-pill btn-none', {'btn-outline-secondary': !slotProps.customizado.row.multiplaCobranca }, {'btn-outline-info': slotProps.customizado.row.multiplaCobranca } ]"
                style="padding: 0.4rem;margin-right: 0.3rem;"
                size="sm"
                title="Cobrança múltipla"
                @click.prevent.stop="cobrancaMultipla($indexDepart, slotProps.customizado.row)"
              >
                <feather-icon
                  style=""
                  icon="RotateCwIcon"
                />
              </b-btn>
              <b-btn
                v-if="slotProps.customizado.row.customizado"
                v-b-tooltip.hover
                variant="none"
                class="btn btn-outline-danger  btn-none rounded-pill btn-none"
                style="padding: 0.4rem;"
                size="sm"
                title="Remover"
                @click.prevent.stop="remover($indexDepart, docsPorDep.departamento, slotProps.customizado.row)"
              >
                <feather-icon
                  style=""
                  icon="TrashIcon"
                />
              </b-btn>
            </span>
            <span v-else>
              <span
                v-for="(tag, $index) in slotProps.customizado.row.tags"
                :key="$index"
                class=""
              >
                <div class="mr-50 tag">
                  <a
                    v-b-tooltip.hover
                    class="badge badge-outline-primary link"
                    style="font-size: 12.5px"
                    :title="tag.valor"
                    @click="editarTag($indexDepart, slotProps.customizado.row, tag)"
                  >
                    <strong>{{ tag.descricao }}:&nbsp;</strong>{{ tag.valor }}
                  </a>
                  <b-btn
                    v-if="hasAcoes"
                    class="btn-primary btn-sm py-0 px-1 remove"
                    variant="none"
                    @click.prevent.stop="removerTag($indexDepart, slotProps.customizado.row, tag)"
                  >
                    <feather-icon
                      style=""
                      icon="TrashIcon"
                    />
                  </b-btn>
                </div>
              </span>
            </span>
          </template>
        </tabela-documento>
      </b-tab>
    </div>

    <b-modal
      :ref="'adicionarTag'"
      title="Adicione tags customizadas para o documento"
      hide-footer
      centered
      no-close-on-backdrop
      @hidden="linhaSelecionada = null"
    >
      <b-row>
        <b-col cols="12">
          <b-form-group label="Escolha a tag">
            <b-select
              v-model="tagAtual.chave"
              :options="opcoesTag"
              :class="tagInvalida.chave ? 'is-select-invalid' : ''"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Adicione as informações">
            <b-input
              v-model="tagAtual.valor"
              :class="tagInvalida.valor ? 'is-select-invalid' : ''"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <b-btn
            class="btn btn-success "
            variant="none"
            @click="salvarTag(tagAtual)"
          >
            Salvar
          </b-btn>
        </b-col>
      </b-row>
    </b-modal>
  </b-tabs>
</template>

<style lang="scss">
.modal .model-header .close {
  padding: 0.05rem 0.5rem !important;
  margin: 0 !important;
}

.tag {
  display: inline-flex;
  align-self: center;
  height: fit-content;

  .badge-outline-primary {
    border: 1px solid var(--primary) !important;
    background-color: transparent;
    color: var(--primary) !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(10rem);
  }

  .link {
    // padding: 0.2rem + 0.2rem;
    border-radius: 4px 0 0 4px;
    cursor: pointer;

    &:hover {
      text-decoration: underline var(--primary);
    }
  }

  .remove {
    padding: 0.2rem !important;
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    border-radius: 0 4px 4px 0;
  }
}

.is-select-invalid {
  border-color: #ea5455 !important;
  background-repeat: no-repeat !important;
  background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem) !important;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  nome: 'DocumentoDepartamento',
  components: {
    TabelaDocumento: () => import('@/shared/components/visualizacao-documento/VisualizacaoDocumento.vue'),
  },
  props: {
    hasAcoes: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    aplicarFiltro: {
      type: Boolean,
      default: false,
    },
    documentosDaEmpresa: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      linhaSelecionada: null,
      tagAtual: {},
      colunasDocumento: [
        { label: 'Descrição', field: 'descricao' },
        { label: 'Complemento', field: 'complemento', useSlot: true },
      ],
      opcoesTag: [
        { text: 'Agência', value: 'agencia' },
        { text: 'Conta', value: 'conta' },
        { text: 'Dígito', value: 'digito' },
        { text: 'Observação', value: 'observacao' }],
      value_: null,
      tagInvalida: {
        tipo: false,
        conteudo: false,
      },
      filtrar: false,
    }
  },
  computed: {
    ...mapGetters('empresa', ['getDocumentosDeDepartamento']),
    valueInner: {
      get() {
        // eslint-disable-next-line no-underscore-dangle
        return this.value_
      },
      set(value) {
        // eslint-disable-next-line no-underscore-dangle
        this.value_ = value
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value && value !== oldValue) {
        this.valueInner = value
      }
    },
    aplicarFiltro(value, oldValue) {
      if (value && value !== oldValue) {
        this.filtrar = value
      }
    },
  },
  created() {
    this.valueInner = this.value
    if (this.hasAcoes) {
      this.colunasDocumento.push({
        label: 'Ações', field: 'acoes', sortable: false, width: '150px', useSlot: true,
      })
    }
  },
  methods: {
    ...mapActions('empresa', [
      'adicionarDocumentoCustom',
      'removerDocumentoCustom',
      'adicionarTagDocumento',
      'removerTagDocumento',
      'editarTagDocumento',
      'propagarParaContatos',
      'selecionarTodos',
      'adiconarTagDocumentoMultiplaCobranca',
    ]),
    documentoSelecionado(indexDepart, departamento, { documento, selecionado }) {
      if (this.documentosDaEmpresa) {
        if (!documento) {
          this.selecionarTodos({ departamento, selecionado })
        } else if (!documento.customizado) {
          this.propagarParaContatos({ departamento, documento, selecionado })
        } else if (!selecionado && documento.customizado) {
          this.removerDocumentoCustom({ indexDepart, departamento, empresaDocumento: documento })
        }
        this.atualizarDadosTabela(departamento)
      }
    },
    remover(indexDepart, departamento, row) {
      this.removerDocumentoCustom({ indexDepart, departamento, empresaDocumento: row })
      this.atualizarDadosTabela(departamento)
    },
    copiar(indexDepart, departamento, row) {
      if (this.documentosDaEmpresa) {
        this.adicionarDocumentoCustom({
          indexDepart, departamento, empresaDocumento: row, copia: true,
        })
        this.atualizarDadosTabela(departamento)
      }
    },
    atualizarDadosTabela(departamento) {
      if (this.documentosDaEmpresa) {
        const docs = this.getDocumentosDeDepartamento(departamento)
        if (this.$refs[`docspordepartamento${departamento.id}`]) {
          this.$refs[`docspordepartamento${departamento.id}`][0].$refresh(docs)
        }
      }
    },
    $refresh(documentos) {
      if (this.documentosDaEmpresa) {
        this.valueInner = documentos
        this.valueInner.forEach(porDepartamento => {
          this.atualizarDadosTabela(porDepartamento.departamento)
        })
      }
    },
    $refreshDepartameto(departamento) {
      if (this.documentosDaEmpresa) {
        this.atualizarDadosTabela(departamento)
      }
    },
    //
    // Métodos para adicionar tags ao documento
    //
    adicionarTag(indexDepart, row) {
      this.linhaSelecionada = {
        indexDepart,
        empresaDocumento: row,
      }
      this.tagAtual = {}
      this.$refs.adicionarTag.show()
    },
    salvarTag(tag) {
      this.tagInvalida.chave = !tag.chave
      this.tagInvalida.valor = tag.chave && !tag.valor

      if (!this.tagInvalida.tipo && !this.tagInvalida.valor) {
        // eslint-disable-next-line no-param-reassign
        tag.descricao = tag.chave === 'observacao' ? 'Obs' : this.opcoesTag.find(f => f.value === tag.chave).text
        if (tag.id || tag.code) {
          this.editarTagDocumento({
            indexDepart: this.linhaSelecionada.indexDepart,
            empresaDocumento: this.linhaSelecionada.empresaDocumento,
            tag,
          })
        } else {
          this.adicionarTagDocumento({
            indexDepart: this.linhaSelecionada.indexDepart,
            empresaDocumento: this.linhaSelecionada.empresaDocumento,
            tag: { ...tag },
          })
        }
        this.tagAtual = {}
        this.linhaSelecionada = null
        this.$refs.adicionarTag.hide()
      }
    },
    editarTag(indexDepart, row, tag) {
      if (this.hasAcoes) {
        this.linhaSelecionada = {
          indexDepart,
          empresaDocumento: row,
        }
        this.tagAtual = tag
        this.$refs.adicionarTag.show()
      }
    },
    removerTag(indexDepart, empresaDocumento, tag) {
      this.removerTagDocumento({
        indexDepart,
        empresaDocumento,
        tag,
      })
    },
    cobrancaMultipla(indexDepar, row) {
      this.adiconarTagDocumentoMultiplaCobranca({
        indexDepart: indexDepar,
        empresaDocumento: row,
      })
    },
  },
}
</script>
